<mat-form-field appearance="outline" style="width: 100%;">
  <mat-label>{{ placeholder }}</mat-label>
  <input matInput [placeholder]="placeholder" [formControl]="control" [matAutocomplete]="auto" />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
    <mat-option *ngIf="isLoading" class="loading-option" disabled>
      <div class="loading-spinner">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Loading...</span>
      </div>
    </mat-option>
    <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option" [ngClass]="{'hidden': isLoading}">
      {{ option.label }}
    </mat-option>
    <mat-option *ngIf="!isLoading && noResults" disabled>
      No matches found
    </mat-option>
  </mat-autocomplete>
</mat-form-field>